import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommonService } from 'src/app/shared/services/common.service';
import { CounterpartDetailService } from './counterpart-detail.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-counterpart-side-draw',
  templateUrl: './counterpart-side-draw.component.html',
  styleUrls: ['./counterpart-detail.component.scss'],
})
export class CounterpartSideDrawComponent {
  @ViewChild('counterpartDetailsSection')
  counterpartDetailsSection!: ElementRef;
  titles: any = [];
  countries = [
    { name: 'Denmark', value: 'DK' },
    { name: 'Estonia', value: 'EE' },
    { name: 'France', value: 'FR' },
    { name: 'Germany', value: 'DE' },
    { name: 'Ireland', value: 'IE' },
    { name: 'Italy', value: 'IT' },
    { name: 'Luxembourg', value: 'LU' },
    { name: 'Netherlands', value: 'NL' },
    { name: 'Poland', value: 'PL' },
    { name: 'Singapore', value: 'SG' },
    { name: 'Spain', value: 'ES' },
    { name: 'Switzerland', value: 'CH' },
    { name: 'UK', value: 'GB' },
    { name: 'USA', value: 'US' },
  ]
  currencies = [{ name: 'Euro', value: 'EUR' }];
  vatTypes = [{ name: 'Value Added Tax (EU)', value: 'eu_vat' }];
  basicDetails: any;
  selectedCounterpart: any;
  selectedVatId: any;
  selectedBankaccount: any;
  selectedContact: any;
  selectedCounterpartAddress: any;
  address = {
    'Address line 1': '',
    'Address line 2': '',
    City: '',
    'Zip code': '',
    State: '',
    Country: '',
  };
  vatIds: any = [];
  bankAccounts: any = [];
  contacts: any = [];
  createCounterpart = {
    type: 'organization',
    name: undefined,
    phone: undefined,
    email: undefined,
    tax_id: undefined,
    street: undefined,
    pincode: undefined,
    city: undefined,
    state: undefined,
    country: undefined,
    addressLine1: undefined,
    addressLine2: undefined,
  };
  createVatId = {
    country: undefined,
    type: undefined,
    value: undefined,
  };
  createBankAccount = {
    account_holder_name: undefined,
    bankName: undefined,
    accountNumber: undefined,
    country: undefined,
    currency: undefined,
    iban: undefined,
    bic: undefined,
    is_primary: false,
  };
  createContact = {
    firstName: undefined,
    lastName: undefined,
    phoneNumber: undefined,
    emailAddress: undefined,
    is_default: false,
  };
  @ViewChild('createCounterpartForm') createCounterpartForm!: NgForm;
  private counterpartDetailSubscription!: Subscription;
  creatingVatId = false;
  creatingBankAccount = false;
  creatingContact = false;
  creatingCounterpart = false;
  isCreate = true;
  isAddContact = false;
  vehicleId: string;
  counterpartId: string;
  fetchingAddress: boolean = false;
  fetchingContacts: boolean = true;
  fetchingVatIds: boolean = false;
  fetchingBankAccounts: boolean = false;
  showContactForm: boolean = false;
  showBankAccountForm: boolean = false;
  showVatIdForm: boolean = false;
  editForm: boolean = false;

  constructor(
    public counterpartDetailService: CounterpartDetailService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.counterpartDetailSubscription =
      this.counterpartDetailService.counterpartDetailsObservable$.subscribe(
        (res: any) => {
          if (res && res.mode === 'detail') {
            this.selectedCounterpart = res;
            //counterpart details
            this.isCreate = false;
            this.isAddContact = false;
            this.counterpartId = res.id;
            this.vehicleId = res.vehicleId;
            this.initDetailsSection(res);
          } else if (res && res.mode === 'create') {
            // create counterpart
            this.resetCreateCounterpartForm();
            this.isCreate = true;
            this.isAddContact = false;
            this.vehicleId = res.vehicleId;
            this.titles = [...['Create Counterparty']];
          } else if (res && res.mode === 'add-contact') {
            // add-contact
            this.isCreate = false;
            this.isAddContact = true;
            this.resetCreateCounterpartForm();
            this.counterpartId = res.id;
            this.vehicleId = res.vehicleId;
            this.titles = [...['Add contact person']];
            this.createContact.is_default = true;
            this.scrollToTop();
            this.showContactForm = true;
          }
        }
      );
  }

  createCounterpartHandler() {
    this.creatingCounterpart = true;
    this.counterpartDetailService
      .createCounterpart(this.vehicleId, {
        data: this.trimStringValues(this.createCounterpart),
      })
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.counterpartId = response.id;
            this.selectedCounterpart = response;
            this.commonService.successNotification(
              'Counterparty created successfully'
            );
            this.counterpartDetailService.setCounterpartListRefresh(true);
            this.initDetailsSection(response);
          }
        },
        error: ({ error }) => {
          this.creatingCounterpart = false;
          if (error.message === 'Counterpart already exists') {
            this.commonService.infoNotification('Counterparty already exists');
          } else {
            this.commonService.errorNotification(
              'Failed to create counterparty'
            );
          }
        },
        complete: () => {
          this.creatingCounterpart = false;
        },
      });
  }

  createvatIdHandler() {
    this.creatingVatId = true;
    this.counterpartDetailService
      .createVatId(this.counterpartId, {
        data: this.trimStringValues(this.createVatId),
      })
      .subscribe({
        next: response => {
          if (response) {
            this.commonService.successNotification('VAT Id added successfully');
            this.hideSubForms();
            this.getCounterpartVatIds();
          }
        },
        error: _error => {
          this.creatingVatId = false;
          this.commonService.errorNotification('Failed to add VAT Id');
        },
        complete: () => {
          this.creatingVatId = false;
        },
      });
  }

  createBankAccountHandler() {
    this.creatingBankAccount = true;
    this.counterpartDetailService
      .createBankAccount(this.counterpartId, {
        data: this.trimStringValues(this.createBankAccount),
      })
      .subscribe({
        next: response => {
          if (response) {
            this.commonService.successNotification(
              'Bank account added successfully'
            );

            this.hideSubForms();
            this.getCounterpartBankAccounts();
          }
        },
        error: ({ error }) => {
          this.creatingBankAccount = false;
          if (error.message === 'Bank Account already exists') {
            this.hideSubForms();
            this.commonService.infoNotification('Bank Account already exists');
          } else {
            this.commonService.errorNotification('Failed to add bank account');
          }
        },
        complete: () => {
          this.creatingBankAccount = false;
        },
      });
  }

  createContactHandler() {
    this.creatingContact = true;
    this.counterpartDetailService
      .createCounterpartContact(this.counterpartId, {
        data: this.trimStringValues(this.createContact),
      })
      .subscribe({
        next: response => {
          if (response) {
            this.commonService.successNotification(
              'Contact person added successfully'
            );
            if (!this.isAddContact) {
              this.hideSubForms();
              this.getCounterpartContacts();
            } else {
              this.counterpartDetailService.closeDrawer();
            }
            this.counterpartDetailService.setCounterpartListRefresh(true);
          }
        },
        error: ({ error }) => {
          this.creatingContact = false;
          if (error.message === 'Contact person already exist') {
            !this.isAddContact && this.hideSubForms();
            this.commonService.infoNotification('Contact person already exist');
          } else {
            this.commonService.errorNotification(
              'Failed to add contact person'
            );
          }
        },
        complete: () => {
          this.creatingContact = false;
        },
      });
  }

  addContactHandler() {
    this.titles.push('Add contact person');
    this.resetContactForm();
    if (!this.contacts.length) {
      this.createContact.is_default = true;
    }
    this.scrollToTop();
    this.showContactForm = true;
  }

  addVatIdsHandler() {
    this.titles.push('Add VAT ID');
    this.resetVATIdForm();
    this.scrollToTop();
    this.showVatIdForm = true;
  }

  addBankAccountHandler() {
    this.titles.push('Add bank account');
    this.resetBankaccountForm();
    if (!this.bankAccounts.length) {
      this.createBankAccount.is_primary = true;
    }
    this.scrollToTop();
    this.showBankAccountForm = true;
  }

  getCounterpartBankAccounts() {
    this.fetchingBankAccounts = true;
    this.counterpartDetailService
      .getCounterpartBankAccounts(this.counterpartId)
      .subscribe({
        next: response => {
          let parsedResponse = JSON.parse(JSON.stringify(response));
          const accounts = parsedResponse.data.sort((a: any, b: any) =>
            a.account_holder_name.localeCompare(
              b.account_holder_name,
              undefined,
              { numeric: true }
            )
          );
          this.bankAccounts = accounts;
        },
        error: _error => {
          this.fetchingBankAccounts = false;
        },
        complete: () => {
          this.fetchingBankAccounts = false;
        },
      });
  }

  getCounterpartVatIds() {
    this.fetchingVatIds = true;
    this.counterpartDetailService
      .getCounterpartVatIds(this.counterpartId)
      .subscribe({
        next: response => {
          let parsedResponse = JSON.parse(JSON.stringify(response));
          const vatIds = parsedResponse.data.sort((a: any, b: any) =>
            a.value.localeCompare(b.value, undefined, { numeric: true })
          );
          this.vatIds = vatIds.map((x: any) => ({
            id: x.id,
            value: x.value,
            countryName: this.getCountry(x.country),
            country: x.country,
            type: x.type,
          }));
        },
        error: _error => {
          this.fetchingVatIds = false;
        },
        complete: () => {
          this.fetchingVatIds = false;
        },
      });
  }

  getCountry(country: string) {
    const found = this.countries.find(c => c.value === country);
    return found ? found.name : country;
  }

  getCounterpartContacts() {
    this.fetchingContacts = true;
    this.counterpartDetailService
      .getCounterpartContacts(this.counterpartId)
      .subscribe({
        next: response => {
          let parsedResponse = JSON.parse(JSON.stringify(response));
          const contacts = parsedResponse.data.sort((a: any, b: any) =>
            (a.firstName + a.lastName).localeCompare(
              b.firstName + b.lastName,
              undefined,
              { numeric: true }
            )
          );
          this.contacts = contacts;
        },
        error: _error => {
          this.fetchingContacts = false;
        },
        complete: () => {
          this.fetchingContacts = false;
        },
      });
  }

  makePrimaryAccount(item: any) {
    this.counterpartDetailService
      .makeDefaultBankaccount(this.counterpartId, item.id)
      .subscribe({
        next: response => {
          if (response) {
            this.commonService.successNotification(
              'Default account changed successfully'
            );
            this.getCounterpartBankAccounts();
          }
        },
        error: _error => {
          this.commonService.errorNotification(
            'Failed to change default account'
          );
        },
        complete: () => {},
      });
  }

  makePrimaryContact(item: any) {
    this.counterpartDetailService
      .makeDefaultContact(this.counterpartId, item.id)
      .subscribe({
        next: response => {
          if (response) {
            this.commonService.successNotification(
              'Default contact changed successfully'
            );
            this.getCounterpartContacts();
            this.counterpartDetailService.setCounterpartListRefresh(true);
          }
        },
        error: _error => {
          this.commonService.errorNotification(
            'Failed to change default contact'
          );
        },
        complete: () => {},
      });
  }

  editCounterpart() {
    this.resetCreateCounterpartForm();
    this.editForm = true;
    const {
      type,
      name,
      phone,
      email,
      tax_id,
      street,
      pincode,
      city,
      state,
      country,
      addressLine1,
      addressLine2,
    } = this.selectedCounterpart;
    this.createCounterpart = {
      type,
      name,
      phone,
      email,
      tax_id,
      street,
      pincode,
      city,
      state,
      country,
      addressLine1,
      addressLine2,
    };
    this.scrollToTop();
    this.isCreate = true;
  }

  editVatId(item: any) {
    this.selectedVatId = item;
    this.resetVATIdForm();
    this.editForm = true;
    this.createVatId = {
      value: item.value,
      country: item.country,
      type: item.type,
    };
    this.scrollToTop();
    this.showVatIdForm = true;
    this.titles.push(item.value);
  }

  editContact(item: any) {
    this.selectedContact = item;
    this.resetContactForm();
    this.editForm = true;
    const { firstName, lastName, phoneNumber, emailAddress, is_default } = item;
    this.createContact = {
      firstName,
      lastName,
      phoneNumber,
      emailAddress,
      is_default,
    };
    this.scrollToTop();
    this.showContactForm = true;
    this.titles.push(`${item.firstName} ${item.lastName}`);
  }

  editBankAccount(item: any) {
    this.selectedBankaccount = item;
    this.resetBankaccountForm();
    this.editForm = true;
    const {
      account_holder_name,
      bankName,
      accountNumber,
      country,
      currency,
      iban,
      bic,
      is_primary,
    } = item;
    this.createBankAccount = {
      account_holder_name,
      bankName,
      accountNumber,
      country,
      currency,
      iban,
      bic,
      is_primary,
    };
    this.scrollToTop();
    this.showBankAccountForm = true;
    this.titles.push(item.account_holder_name);
  }

  updateCounterpartHandler() {
    this.creatingCounterpart = true;
    this.counterpartDetailService
      .updateCounterpart(this.vehicleId, this.counterpartId, {
        data: this.trimStringValues(this.createCounterpart),
      })
      .subscribe({
        next: response => {
          if (response) {
            this.commonService.successNotification(
              'Counterparty updated successfully.'
            );
            this.selectedCounterpart = response;
            this.setCounterpartBasicDetails(response);
            this.hideSubForms();

            this.counterpartDetailService.setCounterpartListRefresh(true);
          }
        },
        error: ({ error }) => {
          this.creatingCounterpart = false;
          if (error.message === 'Counterpart already exists') {
            this.commonService.infoNotification('Counterparty already exists');
          } else {
            this.commonService.errorNotification(
              'Failed to update counterparty'
            );
          }
        },
        complete: () => {
          this.creatingCounterpart = false;
        },
      });
  }

  updateContactHandler() {
    this.creatingContact = true;
    this.counterpartDetailService
      .updateContact(this.counterpartId, this.selectedContact.id, {
        data: this.trimStringValues(this.createContact),
      })
      .subscribe({
        next: response => {
          if (response) {
            this.commonService.successNotification(
              'Contact person updated successfully.'
            );

            this.hideSubForms();
            this.getCounterpartContacts();
            this.counterpartDetailService.setCounterpartListRefresh(true);
          }
        },
        error: ({ error }) => {
          this.creatingContact = false;
          if (error.message === 'Contact person already exist') {
            this.hideSubForms();
            this.commonService.infoNotification('Contact person already exist');
          } else {
            this.commonService.errorNotification(
              'Failed to update contact person'
            );
          }
        },
        complete: () => {
          this.creatingContact = false;
        },
      });
  }

  updateVatIdHandler() {
    this.creatingVatId = true;
    this.counterpartDetailService
      .updateVatId(this.counterpartId, this.selectedVatId.id, {
        data: this.trimStringValues(this.createVatId),
      })
      .subscribe({
        next: response => {
          if (response) {
            this.commonService.successNotification(
              'VAT Id updated successfully'
            );
            this.hideSubForms();
            this.getCounterpartVatIds();
          }
        },
        error: _error => {
          this.creatingVatId = false;
          this.commonService.errorNotification('Failed to update VAT Id');
        },
        complete: () => {
          this.creatingVatId = false;
        },
      });
  }

  updateBankaccountHandler() {
    this.creatingBankAccount = true;
    this.counterpartDetailService
      .updateBankAccount(this.counterpartId, this.selectedBankaccount.id, {
        data: this.trimStringValues(this.createBankAccount),
      })
      .subscribe({
        next: response => {
          if (response) {
            this.commonService.successNotification(
              'Bank account updated successfully'
            );

            this.hideSubForms();
            this.getCounterpartBankAccounts();
          }
        },
        error: ({ error }) => {
          this.creatingBankAccount = false;
          if (error.message === 'Bank Account already exists') {
            this.hideSubForms();
            this.commonService.infoNotification('Bank Account already exists');
          } else {
            this.commonService.errorNotification(
              'Failed to update bank account'
            );
          }
        },
        complete: () => {
          this.creatingBankAccount = false;
        },
      });
  }

  deleteVatId(vatId: string) {
    this.counterpartDetailService
      .deleteVatId(this.counterpartId, vatId)
      .subscribe({
        next: response => {
          let parsedResponse = JSON.parse(JSON.stringify(response));
          this.deleteFromArray(this.vatIds, vatId);

          this.commonService.successNotification('VAT Id deleted successfully');
        },
        error: _error => {
          this.commonService.errorNotification('Failed to delete VAT id');
        },
        complete: () => {},
      });
  }

  deleteContact(contactId: string) {
    this.counterpartDetailService
      .deleteContact(this.counterpartId, contactId)
      .subscribe({
        next: response => {
          let parsedResponse = JSON.parse(JSON.stringify(response));
          this.deleteFromArray(this.contacts, contactId);

          this.commonService.successNotification(
            'Contact deleted successfully'
          );
        },
        error: _error => {
          this.commonService.errorNotification('Failed to delete contact');
        },
        complete: () => {},
      });
  }

  deleteBankAccount(bankaccountId: string) {
    this.counterpartDetailService
      .deleteBankAccount(this.counterpartId, bankaccountId)
      .subscribe({
        next: response => {
          let parsedResponse = JSON.parse(JSON.stringify(response));
          this.deleteFromArray(this.bankAccounts, bankaccountId);
          this.commonService.successNotification(
            'Bank account deleted successfully'
          );
        },
        error: ({ error }) => {
          console.log({ error });
          if (error.error[0].includes('foreign key constraint')) {
            this.commonService.infoNotification(
              'Failed to delete bank account due to linked invoices'
            );
          } else {
            this.commonService.errorNotification(
              'Failed to delete bank account'
            );
          }
        },
        complete: () => {},
      });
  }

  initDetailsSection(data: any) {
    this.setCounterpartBasicDetails(data);
    this.hideSubForms();
    this.getCounterpartContacts();
    this.getCounterpartVatIds();
    this.getCounterpartBankAccounts();
  }

  setCounterpartBasicDetails(res: any) {
    const titles = [];
    titles.push(res.name);
    this.titles = [...titles];
    const basicDetails = {
      Category:
        res.type === 'organization' ? 'Legal entity' : 'Private Individual',
      Phone: res.phone,
      Email: res.email,
      Address: [res.addressLine1, res.addressLine2].filter(Boolean).join(', '),
      City: res.city,
      State: res.state,
      'Zip code': res.pincode,
      Country: res.country
        ? this.countries.find(c => c.value === res.country)!.name
        : '',
    };
    if (res.type === 'organization') {
      this.basicDetails = { 'Company name': res.name, ...basicDetails };
    } else {
      this.basicDetails = {
        'Private Individual Name': res.name,
        ...basicDetails,
      };
    }
  }

  convertObjectToArray(
    obj: Record<string, any>
  ): { key: string; value: any }[] {
    return Object.entries(obj).map(([key, value]) => ({ key, value }));
  }

  hideSubForms() {
    this.titles.length = 1;
    this.isCreate = false;
    this.showContactForm = false;
    this.showVatIdForm = false;
    this.showBankAccountForm = false;
    this.editForm = false;
    this.scrollToTop();
  }

  deleteFromArray(array: any, id: string) {
    const index = array.findIndex((item: any) => item.id === id);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  scrollToTop() {
    if (this.counterpartDetailsSection) {
      this.counterpartDetailsSection.nativeElement.scrollTo({
        top: 0,
      });
    }
  }

  resetCreateCounterpartForm() {
    this.createCounterpart = {
      type: 'organization',
      name: undefined,
      phone: undefined,
      email: undefined,
      tax_id: undefined,
      street: undefined,
      pincode: undefined,
      city: undefined,
      state: undefined,
      country: undefined,
      addressLine1: undefined,
      addressLine2: undefined,
    };
  }

  resetBankaccountForm() {
    this.createBankAccount = {
      account_holder_name: undefined,
      accountNumber: undefined,
      bankName: undefined,
      country: undefined,
      currency: undefined,
      iban: undefined,
      bic: undefined,
      is_primary: false,
    };
  }

  resetVATIdForm() {
    this.createVatId = {
      country: undefined,
      type: undefined,
      value: undefined,
    };
  }

  resetContactForm() {
    this.createContact = {
      firstName: undefined,
      lastName: undefined,
      phoneNumber: undefined,
      emailAddress: undefined,
      is_default: false,
    };
  }

  ngOnDestroy() {
    if (this.counterpartDetailSubscription) {
      this.counterpartDetailSubscription.unsubscribe();
    }
  }

  trimStringValues(obj: any) {
    const trimmed: any = {};

    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        trimmed[key] = obj[key].trim();
      } else {
        trimmed[key] = obj[key];
      }
    }

    return trimmed;
  }
}
